import {
    FETCH_CATEGORIES,
    FETCH_CATEGORIES_SUCCESS,
    FETCH_CATEGORIES_FAILED,
    EDIT_CATEGORY
  } from "../store/types";
  
  const INITIAL_STATE = {
    categories: null,
    loading: false,
    error: {
      flag: false,
      msg: null
    }
  }
  
  export const categorylistreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_CATEGORIES:
        return {
          ...state,
          loading: true
        };
      case FETCH_CATEGORIES_SUCCESS:
        return {
          ...state,
          categories: action.payload,
          loading: false
        };
      case FETCH_CATEGORIES_FAILED:
        return {
          ...state,
          categories: null,
          loading: false,
          error: {
            flag: true,
            msg: action.payload
          }
        };
      case EDIT_CATEGORY:
        return state;
      default:
        return state;
    }
  };